import { gql } from '../../../__generated__/graphql/catalog'

export const GET_COLLECTION = gql(`
  query GetCatalogCollection(
    $after: ID
    $first: Int!
    $nextPageDataOnly: Boolean!
    $filters: [ProductCatalogProductFilterInput!]!
    $collectionHandle: String!
  ) {
    productCatalogCollection(handle: $collectionHandle) {
      id
      handle
      items(filters: $filters, first: $first, after: $after) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        filters @skip(if: $nextPageDataOnly) {
          __typename
          ...CollectionProductFilter 
        }
        nodes {
          variantGroup {
            ...CollectionItemVariantGroup
          }
        }
      }
    }
  }
`)
